import React from 'react'

const DashDispatchs = () => {
  return (
    <div>DashDispatchs</div>
  )
}

export default DashDispatchs